import { State } from '../state';

export const LogbookSelectors = {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    logbook: (state: State) => state.Logbook,
};
